import { render, staticRenderFns } from "./ActiveGroupRejected07XsS.vue?vue&type=template&id=78d3c452"
import script from "./ActiveGroupRejected07XsS.vue?vue&type=script&lang=ts"
export * from "./ActiveGroupRejected07XsS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports